import { render, staticRenderFns } from "./TableMeta.vue?vue&type=template&id=9010af48&scoped=true&lang=pug&"
import script from "./TableMeta.vue?vue&type=script&lang=ts&"
export * from "./TableMeta.vue?vue&type=script&lang=ts&"
import style0 from "./TableMeta.vue?vue&type=style&index=0&id=9010af48&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9010af48",
  null
  
)

export default component.exports